import {
	DOC_INIT,
	GET_DOCS_REQ_FAILED,
	GET_DOCS_REQ_INITIALIZE,
	GET_DOCS_REQ_LOADING,
	GET_DOCS_REQ_SUCCESSED
} from "../actions/types";
const initialState = {
	docs: {},
	Onedocs: {},
	isLoading: false,
	isDone: false,
	isFailed: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case DOC_INIT:
			return {...state,
				docs: {},
	Onedocs: {},
	isLoading: false,
	isDone: false,
	isFailed: false,
			};
		case GET_DOCS_REQ_LOADING:
			return {
				...state,
				isLoading: true,
				isDone: false,
				isFailed: false,
			};
		case GET_DOCS_REQ_SUCCESSED:
			return {
				...state,
				docs: action.payload,

				isDone: true,
				isLoading: false,
				isFailed: false,
			};
		case GET_DOCS_REQ_FAILED:
			return {
				...state,
				isDone: false,
				isFailed: true,
				isLoading: false,
			};
		case GET_DOCS_REQ_INITIALIZE:
			return {
				...state,
				docs: {},
				Onedocs: {},
				isDone: false,
				isFailed: false,
				isLoading: false,
			};

		default:
			return state;
	}
}
